module.exports = __webpack_public_path__ + "img/liste-drucken-aktiv.f3fa315d.svg";